import React from 'react';
import { useParams } from 'react-router-dom';

const SectionDetail = () => {
  const { section } = useParams();

  return (
    <div>
      <h1>{section.replace(/-/g, ' ')}</h1>
      <p>Content for {section} section.</p>
    </div>
  );
};

export default SectionDetail;
